module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/new/store_images/1_de602026e7f78d01f55da8582a6e4690.png";